import { render, staticRenderFns } from "./BoxFornecedor.vue?vue&type=template&id=0b0f8f9c&"
import script from "./BoxFornecedor.vue?vue&type=script&lang=js&"
export * from "./BoxFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BoxFornecedor.vue"
export default component.exports